import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import PageState from './modules/pageState'
import JMeAiBotState from './modules/jMeAiBotState'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: [PageState, JMeAiBotState],
  plugins: process.env.NODE_ENV !== 'production' ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js